import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { Button } from 'shared/components';

import theme from '../buttons.scss';

const propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  isLoading: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
  label: PropTypes.string,
  testId: PropTypes.string,
  size: PropTypes.oneOf(['large', 'medium', 'small', 'xsmall']),
  iconDontFlipOnRtl: PropTypes.bool,
};

const defaultProps = {
  label: null,
  testId: 'save-button',
  size: undefined,
  iconDontFlipOnRtl: false,
};

const SaveButton = ({ intl, isLoading, isDisabled, handleClick, label, testId, size, iconDontFlipOnRtl }) => (
  <Button
    testId={ testId }
    label={ label || intl.formatMessage({ id: 'General.Save', defaultMessage: '** Save' }) }
    className={ theme.saveButton }
    iconName="check"
    iconPositionLeft
    isLoading={ isLoading }
    background="primary"
    disabled={ isLoading || isDisabled }
    onClick={ handleClick }
    size={ size }
    iconDontFlipOnRtl={ iconDontFlipOnRtl }
  />
);

SaveButton.propTypes = propTypes;
SaveButton.defaultProps = defaultProps;

export default injectIntl(SaveButton);
